<template>
  <div class="dashboard">
    <h2 class="page-title">紅利折抵卡片登記</h2>

    <!-- Registered Cards Container -->
    <div class="registered-cards">
      <!-- <div v-if="registered_cards.length === 0" class="no-cards">
        No registered credit cards found.
      </div> -->

      <div class="cards-container">
        <!-- "+" Card to Open Modal -->
        <div class="add-card" @click="openModal">
          <p class="subtitle">使用您的紅利折抵卡片扣抵停車繳費</p>

          <div class="add-icon-text">
            <div class="add-icon">+</div>
            <div class="add-text">新增卡片</div>
          </div>
        </div>

        <!-- Registered Credit Cards -->
        <div v-for="card in registered_cards" :key="card.id" class="registered-card">
          <div class="card-content">
            <div class="card-image">
              <img :src="getOfferCardImageURL(card.offer_card_id)"
                :alt="`${capitalizeFirstLetter(card.card_type)} Image`" />
            </div>
            <div class="card-details">
              <p class="bank-info">{{ card.bank }} | {{ card.name }}</p>
              <p class="card-number">{{ maskCardNumber(card.card_number) }}</p>
              <p class="status">
                <img src="@/assets/icon_success.png" alt="success" class="status-icon" /> 已登記優惠折抵
              </p>
            </div>
            <div class="del-but-div">
              <button class="delete-button"
                @click="attempRemoveRegisteredCard(card.id, card.card_type, card.card_number)">
                <img src="@/assets/delete_icon.png" alt="delete" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RegisterCardSuccess v-if="showSuccess" @close="closeSuccess" />

    <CardNumberModal v-if="enterCardNumber" :selectedOfferCard="selectedOfferCard"
      @go-back-to-select-card="goBackToSelectCard" @card-number-entered="cardNumberEntered"
      @close-modal="closeCardNumberModal" />


    <!-- Modal Component -->
    <OfferCardModal :visible="showModal" :offer_cards="offer_cards" @close="closeModal"
      @add-card="attempAddToRegisteredCard" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OfferCardModal from './OfferCardModal.vue';
import CardNumberModal from './CardNumberModal.vue';
import RegisterCardSuccess from './RegisterCardSuccess.vue';
import { getFullImageURL, maskCardNumber } from '@/util/util';

export default {
  name: 'CardBoard',
  components: {
    OfferCardModal,
    CardNumberModal,
    RegisterCardSuccess,
  },
  computed: {
    ...mapGetters(['user', 'registered_cards', 'offer_cards']),
  },
  data() {
    return {
      showSuccess: false,
      showModal: false,
      enterCardNumber: false,
      selectedOfferCard: { bank: '', name: '', card_image: '' },
    };
  },
  methods: {
    ...mapActions(['removeRegisteredCard', 'addToRegisteredCard']), // Assuming you have an action to add a registered card

    getFullImageURL,

    // 卡號遮碼統一走 util 的 maskCardNumber（前六後四），
    // 不再各畫面自己實作，避免遮碼規則不一致
    maskCardNumber,

    capitalizeFirstLetter(str) {
      if (typeof str !== 'string' || str.length === 0) return str;
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    getOfferCardImageURL(offerCardId) {
      const cardImageDict = {};
      this.offer_cards.forEach(card => {
        cardImageDict[card.id] = card.card_image;
      });

      const card_image_path = cardImageDict[offerCardId];
      if (!card_image_path) {
        return getFullImageURL('/images/placeholder.png');
      }

      return getFullImageURL( card_image_path);
    },

    attempRemoveRegisteredCard(cardId, card_type, card_number) {
      card_number = card_number || '**** **** **** ****';
      if (confirm(`您確定要移除卡片 ${this.capitalizeFirstLetter(card_type)}，卡號末四碼為 ${card_number.slice(-4)} 嗎？`)) {        
        this.removeRegisteredCard(cardId);
      }
    },

    async attempAddToRegisteredCard(offerCard) {
      this.enterCardNumber = false;
      this.showModal = false;
      this.selectedOfferCard = offerCard;
      this.enterCardNumber = true;

      if (this.enterCardNumber) {
        return;
        // alert('Add to registered card');
        // this.addToRegisteredCard(offerCard);
      }

      const card_number = prompt(`請輸入 ${offerCard.bank} ${offerCard.name} 的卡號`);
      if (!card_number) return;
      if (confirm(`確定要新增卡片 ${offerCard.bank} ${offerCard.name}  ${card_number}?`)) {
        offerCard.card_number = card_number;
        const result = this.addToRegisteredCard(offerCard);
        if (result) {
          alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
          this.closeModal();
        } else {
          alert('無法新增信用卡。請再試一次。');
        }
      }
    },

    goBackToSelectCard() {
      this.enterCardNumber = false;
      this.showModal = true;
    },

    closeCardNumberModal() {
      this.enterCardNumber = false;
    },

    async cardNumberEntered({ key, value, expireDate }) {
      console.log('Card Number Entered:', key, maskCardNumber(value));
      this.selectedOfferCard.card_number = value;
      this.selectedOfferCard.expire_date = expireDate;
      const offerCard = this.selectedOfferCard;
      // this.addToRegisteredCard(this.selectedOfferCard);
      console.log('Offer Card:', { ...offerCard, card_number: maskCardNumber(offerCard.card_number) });

      const result = await this.addToRegisteredCard(offerCard);
      console.log('Add Register Result:', result);
      if (result.success) {
        // alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
        // this.closeModal();
        this.showSuccess = true;
          // alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
          // this.closeModal();        
        this.enterCardNumber = false;

      } else {
        alert('無法新增信用卡。請再試一次。');

      }

      // this.addToRegisteredCard({ ...this.selectedOfferCard, [key]: value });
    },

    closeSuccess() {
      this.showSuccess = false;
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 0px;
  padding-bottom: 160px;
  text-align: center;

  background-color: var(--background-gray);
}



.subtitle {
  margin: 0px;
  padding: 0px;

  position: absolute;

  top: 260px;

  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray13);
  /* margin-bottom: 20px; */
}

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border: 2px dashed var(--green03); */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);


  border-radius: 20px;
  width: 938px;
  height: 282px;
  cursor: pointer;
  transition: background-color 0.2s;

  padding: 0px;
  box-sizing: border-box;
  margin: 0px;

  background-color: white;

}

.add-card:hover {
  background-color: #e6f0ff;
  border-color: var(--green02);
}

.add-icon-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.add-icon {
  font-size: 50px;
  font-weight: 200;
  color: var(--green03);
}

.add-text {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);
}

.registered-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  width: 936px;
  height: 282px;
  padding: 66px 48px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;

  box-sizing: border-box;
}

.registered-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.card-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}

.card-image {
  width: 240px;
  height: 150px;
  margin-right: 48px;
  /* margin-left: 10px; */
}

.card-image img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

.card-details {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;

  height: 150px;
  /* height:100%; */
  /* background-color: red; */
}

.bank-info {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin: 0px;
}

.card-number {
  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin-top: 12px;
  margin-bottom: 48px;
}

.status {
  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--green03);

  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0px;
}

.status-icon {
  width: 32px;
  height: 32px;
  margin-right: 16px;

  position: relative;
  top: -2px;
}

.del-but-div {
  /* position: relative; */
  display: flex;
  flex-direction: row;
  /* background-color: red; */
  /* border: 1px solid red; */
  /* margin:auto 0px; */
}

.delete-button {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  transition: color 0.2s;
}

.delete-button img {
  width: 32px;
  height: 32px;
}

.delete-button:hover img {
  filter: brightness(0.8);
}

/* Responsive Styles for screens smaller than 560px */
@media (max-width: 560px) {

  .cards-container {
    width: 343px;
    gap: 12px;

    margin: 0 auto;
  }

  .add-card {
    padding: 0px;
  }

  .add-card,
  .registered-card {
    width: 343px;
    height: 80px;
    /* border-radius: 8px; */

    box-sizing: border-box;
  }

  .subtitle {
    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    position: static;
    top: 0px;

  }



  .add-icon-text {
    gap: 8px;
  }

  .add-icon {
    /* //styleName: sm/bold; */
    font-size: 30px;
    margin-right: 0px;

  }

  .add-text {
    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }



  .registered-card {
    padding: 20px 12px;
    flex-direction: row;
    align-items: flex-start;
  }

  .card-content {
    flex-direction: row;

  }

  .card-image {
    width: 64px;
    height: 40px;

    /* margin-bottom: 10px;
     */
    margin: 0;
    margin-right: 8px;
  }

  .card-image img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .card-details {
    text-align: left;
  }

  .bank-info {

    /* //styleName: xs/bold; */
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }

  .card-number,
  .status {
    /* //styleName: xs/regular; */
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 4px;
  }

  .delete-button {
    /* position: relative; */
    /* align-self: flex-end; */
    /* margin-top: 10px; */
    right: 16px;
  }

  .delete-button img {
    width: 24px;
    height: 24px;
  }

  .status {
    display: none;
  }
}
</style>
